import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useToken from "../useToken";
import MenuAppBar from "../components/MenuApp";

// 1. Importaciones de la versión VIEJA (v4)
import { createTheme as createThemeV4, ThemeProvider as ThemeProviderV4 } from '@material-ui/core/styles';

// 2. Importaciones de la versión NUEVA (v5)
import { createTheme as createThemeV5, ThemeProvider as ThemeProviderV5 } from '@mui/material/styles';

// 3. Tema para componentes antiguos (v4)
const themeV4 = createThemeV4({
  palette: {
    primary: { 
        main: '#3f51b5' 
    },
    secondary: {
      main: '#d32f2f', 
    },
  },
});

// 4. Tema para componentes nuevos (v5)
const themeV5 = createThemeV5({
  palette: {
    primary: { 
        main: '#3f51b5' 
    },
    secondary: {
      main: '#d32f2f', 
    },
    error: {
      main: '#d32f2f', 
    },   
  },
});

const PrivateRoute = ({ component: Component, ...rest }) => {
    const verifyToken = useToken.verifyExpToken();

    return (
        <Route
            {...rest}
            render={props =>
                verifyToken ? (
                    <ThemeProviderV4 theme={themeV4}>
                        <ThemeProviderV5 theme={themeV5}>
                            <div>
                                <MenuAppBar/>
                                <div style={{ margin: 12 }}>
                                    <Component {...props} />
                                </div>
                            </div>
                        </ThemeProviderV5>
                    </ThemeProviderV4>
                ) : (
                    <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                )
            }
        />
    );
};

export default PrivateRoute;